import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import './assets/css/crm-theme.css'

import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'

import SoftUIDashboard from './soft-ui-dashboard'
import setupInterceptors from './interceptores/setupInterceptors'

const appInstance = createApp(App)

setupInterceptors(store)

appInstance.use(router)
appInstance.use(store)
appInstance.use(SoftUIDashboard)


appInstance.component('VSelect', vSelect)

appInstance.mount('#app')
appInstance.config.errorHandler = (err, vm, info) => {
    console.error('Error:', err);
    console.warn('Vue instance:', vm);
    console.info('Info:', info);
};
